const countries: Array<{
  name: string;
  emojiFlag: string;
  code: string;
  dialCode: string;
  flag?: "red" | "yellow";
}> = [
  {
    name: "United States",
    emojiFlag: "🇺🇸",
    code: "US",
    dialCode: "+1",
  },
  {
    name: "Afghanistan",
    emojiFlag: "🇦🇫",
    code: "AF",
    dialCode: "+93",
  },
  {
    name: "Åland Islands",
    emojiFlag: "🇦🇽",
    code: "AX",
    dialCode: "+358",
  },
  {
    name: "Albania",
    emojiFlag: "🇦🇱",
    code: "AL",
    dialCode: "+355",
  },
  {
    name: "Algeria",
    emojiFlag: "🇩🇿",
    code: "DZ",
    dialCode: "+213",
  },
  {
    name: "American Samoa",
    emojiFlag: "🇦🇸",
    code: "AS",
    dialCode: "+1684",
  },
  {
    name: "Andorra",
    emojiFlag: "🇦🇩",
    code: "AD",
    dialCode: "+376",
  },
  {
    name: "Angola",
    emojiFlag: "🇦🇴",
    code: "AO",
    dialCode: "+244",
  },
  {
    name: "Anguilla",
    emojiFlag: "🇦🇮",
    code: "AI",
    dialCode: "+1264",
  },
  {
    name: "Antarctica",
    emojiFlag: "🇦🇶",
    code: "AQ",
    dialCode: "+672",
  },
  {
    name: "Antigua and Barbuda",
    emojiFlag: "🇦🇬",
    code: "AG",
    dialCode: "+1268",
  },
  {
    name: "Argentina",
    emojiFlag: "🇦🇷",
    code: "AR",
    dialCode: "+54",
  },
  {
    name: "Armenia",
    emojiFlag: "🇦🇲",
    code: "AM",
    dialCode: "+374",
  },
  {
    name: "Aruba",
    emojiFlag: "🇦🇼",
    code: "AW",
    dialCode: "+297",
  },
  {
    name: "Australia",
    emojiFlag: "🇦🇺",
    code: "AU",
    dialCode: "+61",
  },
  {
    name: "Austria",
    emojiFlag: "🇦🇹",
    code: "AT",
    dialCode: "+43",
  },
  {
    name: "Azerbaijan",
    emojiFlag: "🇦🇿",
    code: "AZ",
    dialCode: "+994",
  },
  {
    name: "Bahamas",
    emojiFlag: "🇧🇸",
    code: "BS",
    dialCode: "+1242",
  },
  {
    name: "Bahrain",
    emojiFlag: "🇧🇭",
    code: "BH",
    dialCode: "+973",
  },
  {
    name: "Bangladesh",
    emojiFlag: "🇧🇩",
    code: "BD",
    dialCode: "+880",
  },
  {
    name: "Barbados",
    emojiFlag: "🇧🇧",
    code: "BB",
    dialCode: "+1246",
  },
  {
    name: "Belarus",
    emojiFlag: "🇧🇾",
    code: "BY",
    dialCode: "+375",
    flag: "red",
  },
  {
    name: "Belgium",
    emojiFlag: "🇧🇪",
    code: "BE",
    dialCode: "+32",
  },
  {
    name: "Belize",
    emojiFlag: "🇧🇿",
    code: "BZ",
    dialCode: "+501",
  },
  {
    name: "Benin",
    emojiFlag: "🇧🇯",
    code: "BJ",
    dialCode: "+229",
  },
  {
    name: "Bermuda",
    emojiFlag: "🇧🇲",
    code: "BM",
    dialCode: "+1441",
  },
  {
    name: "Bhutan",
    emojiFlag: "🇧🇹",
    code: "BT",
    dialCode: "+975",
  },
  {
    name: "Bolivia",
    emojiFlag: "🇧🇴",
    code: "BO",
    dialCode: "+591",
  },
  {
    name: "Bosnia and Herzegovina",
    emojiFlag: "🇧🇦",
    code: "BA",
    dialCode: "+387",
  },
  {
    name: "Botswana",
    emojiFlag: "🇧🇼",
    code: "BW",
    dialCode: "+267",
  },
  {
    name: "Bouvet Island",
    emojiFlag: "🇧🇻",
    code: "BV",
    dialCode: "+47",
  },
  {
    name: "Brazil",
    emojiFlag: "🇧🇷",
    code: "BR",
    dialCode: "+55",
  },
  {
    name: "British Indian Ocean Territory",
    emojiFlag: "🇮🇴",
    code: "IO",
    dialCode: "+246",
  },
  {
    name: "Brunei Darussalam",
    emojiFlag: "🇧🇳",
    code: "BN",
    dialCode: "+673",
  },
  {
    name: "Bulgaria",
    emojiFlag: "🇧🇬",
    code: "BG",
    dialCode: "+359",
  },
  {
    name: "Burkina Faso",
    emojiFlag: "🇧🇫",
    code: "BF",
    dialCode: "+226",
  },
  {
    name: "Burundi",
    emojiFlag: "🇧🇮",
    code: "BI",
    dialCode: "+257",
  },
  {
    name: "Cambodia",
    emojiFlag: "🇰🇭",
    code: "KH",
    dialCode: "+855",
  },
  {
    name: "Cameroon",
    emojiFlag: "🇨🇲",
    code: "CM",
    dialCode: "+237",
  },
  {
    name: "Canada",
    emojiFlag: "🇨🇦",
    code: "CA",
    dialCode: "+1",
  },
  {
    name: "Cape Verde",
    emojiFlag: "🇨🇻",
    code: "CV",
    dialCode: "+238",
  },
  {
    name: "Cayman Islands",
    emojiFlag: "🇰🇾",
    code: "KY",
    dialCode: "+1345",
  },
  {
    name: "Central African Republic",
    emojiFlag: "🇨🇫",
    code: "CF",
    dialCode: "+236",
  },
  {
    name: "Chad",
    emojiFlag: "🇹🇩",
    code: "TD",
    dialCode: "+235",
  },
  {
    name: "Chile",
    emojiFlag: "🇨🇱",
    code: "CL",
    dialCode: "+56",
  },
  {
    name: "China",
    emojiFlag: "🇨🇳",
    code: "CN",
    dialCode: "+86",
  },
  {
    name: "Christmas Island",
    emojiFlag: "🇨🇽",
    code: "CX",
    dialCode: "+61",
  },
  {
    name: "Cocos (Keeling) Islands",
    emojiFlag: "🇨🇨",
    code: "CC",
    dialCode: "+61",
  },
  {
    name: "Colombia",
    emojiFlag: "🇨🇴",
    code: "CO",
    dialCode: "+57",
    flag: "red",
  },
  {
    name: "Comoros",
    emojiFlag: "🇰🇲",
    code: "KM",
    dialCode: "+269",
  },
  {
    name: "Congo",
    emojiFlag: "🇨🇬",
    code: "CG",
    dialCode: "+242",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    emojiFlag: "🇨🇩",
    code: "CD",
    dialCode: "+243",
  },
  {
    name: "Cook Islands",
    emojiFlag: "🇨🇰",
    code: "CK",
    dialCode: "+682",
  },
  {
    name: "Costa Rica",
    emojiFlag: "🇨🇷",
    code: "CR",
    dialCode: "+506",
  },
  {
    name: "Côte d'Ivoire",
    emojiFlag: "🇨🇮",
    code: "CI",
    dialCode: "+225",
  },
  {
    name: "Croatia",
    emojiFlag: "🇭🇷",
    code: "HR",
    dialCode: "+385",
  },
  {
    name: "Cuba",
    emojiFlag: "🇨🇺",
    code: "CU",
    dialCode: "+53",
    flag: "red",
  },
  {
    name: "Cyprus",
    emojiFlag: "🇨🇾",
    code: "CY",
    dialCode: "+357",
  },
  {
    name: "Czech Republic",
    emojiFlag: "🇨🇿",
    code: "CZ",
    dialCode: "+420",
  },
  {
    name: "Denmark",
    emojiFlag: "🇩🇰",
    code: "DK",
    dialCode: "+45",
  },
  {
    name: "Djibouti",
    emojiFlag: "🇩🇯",
    code: "DJ",
    dialCode: "+253",
  },
  {
    name: "Dominica",
    emojiFlag: "🇩🇲",
    code: "DM",
    dialCode: "+1767",
  },
  {
    name: "Dominican Republic",
    emojiFlag: "🇩🇴",
    code: "DO",
    dialCode: "+1849",
  },
  {
    name: "Ecuador",
    emojiFlag: "🇪🇨",
    code: "EC",
    dialCode: "+593",
  },
  {
    name: "Egypt",
    emojiFlag: "🇪🇬",
    code: "EG",
    dialCode: "+20",
  },
  {
    name: "El Salvador",
    emojiFlag: "🇸🇻",
    code: "SV",
    dialCode: "+503",
  },
  {
    name: "Equatorial Guinea",
    emojiFlag: "🇬🇶",
    code: "GQ",
    dialCode: "+240",
  },
  {
    name: "Eritrea",
    emojiFlag: "🇪🇷",
    code: "ER",
    dialCode: "+291",
  },
  {
    name: "Estonia",
    emojiFlag: "🇪🇪",
    code: "EE",
    dialCode: "+372",
  },
  {
    name: "Ethiopia",
    emojiFlag: "🇪🇹",
    code: "ET",
    dialCode: "+251",
  },
  {
    name: "Falkland Islands (Malvinas)",
    emojiFlag: "🇫🇰",
    code: "FK",
    dialCode: "+500",
  },
  {
    name: "Faroe Islands",
    emojiFlag: "🇫🇴",
    code: "FO",
    dialCode: "+298",
  },
  {
    name: "Fiji",
    emojiFlag: "🇫🇯",
    code: "FJ",
    dialCode: "+679",
  },
  {
    name: "Finland",
    emojiFlag: "🇫🇮",
    code: "FI",
    dialCode: "+358",
  },
  {
    name: "France",
    emojiFlag: "🇫🇷",
    code: "FR",
    dialCode: "+33",
  },
  {
    name: "French Guiana",
    emojiFlag: "🇬🇫",
    code: "GF",
    dialCode: "+594",
  },
  {
    name: "French Polynesia",
    emojiFlag: "🇵🇫",
    code: "PF",
    dialCode: "+689",
  },
  {
    name: "French Southern Territories",
    emojiFlag: "🇹🇫",
    code: "TF",
    dialCode: "+262",
  },
  {
    name: "Gabon",
    emojiFlag: "🇬🇦",
    code: "GA",
    dialCode: "+241",
  },
  {
    name: "Gambia",
    emojiFlag: "🇬🇲",
    code: "GM",
    dialCode: "+220",
  },
  {
    name: "Georgia",
    emojiFlag: "🇬🇪",
    code: "GE",
    dialCode: "+995",
  },
  {
    name: "Germany",
    emojiFlag: "🇩🇪",
    code: "DE",
    dialCode: "+49",
  },
  {
    name: "Ghana",
    emojiFlag: "🇬🇭",
    code: "GH",
    dialCode: "+233",
  },
  {
    name: "Gibraltar",
    emojiFlag: "🇬🇮",
    code: "GI",
    dialCode: "+350",
  },
  {
    name: "Greece",
    emojiFlag: "🇬🇷",
    code: "GR",
    dialCode: "+30",
  },
  {
    name: "Greenland",
    emojiFlag: "🇬🇱",
    code: "GL",
    dialCode: "+299",
  },
  {
    name: "Grenada",
    emojiFlag: "🇬🇩",
    code: "GD",
    dialCode: "+1473",
  },
  {
    name: "Guadeloupe",
    emojiFlag: "🇬🇵",
    code: "GP",
    dialCode: "+590",
  },
  {
    name: "Guam",
    emojiFlag: "🇬🇺",
    code: "GU",
    dialCode: "+1671",
  },
  {
    name: "Guatemala",
    emojiFlag: "🇬🇹",
    code: "GT",
    dialCode: "+502",
  },
  {
    name: "Guernsey",
    emojiFlag: "🇬🇬",
    code: "GG",
    dialCode: "+44",
  },
  {
    name: "Guinea",
    emojiFlag: "🇬🇳",
    code: "GN",
    dialCode: "+224",
  },
  {
    name: "Guinea-Bissau",
    emojiFlag: "🇬🇼",
    code: "GW",
    dialCode: "+245",
  },
  {
    name: "Guyana",
    emojiFlag: "🇬🇾",
    code: "GY",
    dialCode: "+592",
  },
  {
    name: "Haiti",
    emojiFlag: "🇭🇹",
    code: "HT",
    dialCode: "+509",
  },
  {
    name: "Heard Island and Mcdonald Islands",
    emojiFlag: "🇭🇲",
    code: "HM",
    dialCode: "+672",
  },
  {
    name: "Holy See (Vatican City State)",
    emojiFlag: "🇻🇦",
    code: "VA",
    dialCode: "+379",
  },
  {
    name: "Honduras",
    emojiFlag: "🇭🇳",
    code: "HN",
    dialCode: "+504",
  },
  {
    name: "Hong Kong",
    emojiFlag: "🇭🇰",
    code: "HK",
    dialCode: "+852",
  },
  {
    name: "Hungary",
    emojiFlag: "🇭🇺",
    code: "HU",
    dialCode: "+36",
  },
  {
    name: "Iceland",
    emojiFlag: "🇮🇸",
    code: "IS",
    dialCode: "+354",
  },
  {
    name: "India",
    emojiFlag: "🇮🇳",
    code: "IN",
    dialCode: "+91",
  },
  {
    name: "Indonesia",
    emojiFlag: "🇮🇩",
    code: "ID",
    dialCode: "+62",
  },
  {
    name: "Iran",
    emojiFlag: "🇮🇷",
    code: "IR",
    dialCode: "+98",
    flag: "red",
  },
  {
    name: "Iraq",
    emojiFlag: "🇮🇶",
    code: "IQ",
    dialCode: "+964",
  },
  {
    name: "Ireland",
    emojiFlag: "🇮🇪",
    code: "IE",
    dialCode: "+353",
  },
  {
    name: "Isle of Man",
    emojiFlag: "🇮🇲",
    code: "IM",
    dialCode: "+44",
  },
  {
    name: "Israel",
    emojiFlag: "🇮🇱",
    code: "IL",
    dialCode: "+972",
  },
  {
    name: "Italy",
    emojiFlag: "🇮🇹",
    code: "IT",
    dialCode: "+39",
  },
  {
    name: "Jamaica",
    emojiFlag: "🇯🇲",
    code: "JM",
    dialCode: "+1876",
  },
  {
    name: "Japan",
    emojiFlag: "🇯🇵",
    code: "JP",
    dialCode: "+81",
  },
  {
    name: "Jersey",
    emojiFlag: "🇯🇪",
    code: "JE",
    dialCode: "+44",
  },
  {
    name: "Jordan",
    emojiFlag: "🇯🇴",
    code: "JO",
    dialCode: "+962",
  },
  {
    name: "Kazakhstan",
    emojiFlag: "🇰🇿",
    code: "KZ",
    dialCode: "+7",
  },
  {
    name: "Kenya",
    emojiFlag: "🇰🇪",
    code: "KE",
    dialCode: "+254",
  },
  {
    name: "Kiribati",
    emojiFlag: "🇰🇮",
    code: "KI",
    dialCode: "+686",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    emojiFlag: "🇰🇵",
    code: "KP",
    dialCode: "+850",
    flag: "red",
  },
  {
    name: "Korea, Republic of South Korea",
    emojiFlag: "🇰🇷",
    code: "KR",
    dialCode: "+82",
  },
  {
    name: "Kosovo",
    emojiFlag: "🇽🇰",
    code: "XK",
    dialCode: "+383",
  },
  {
    name: "Kuwait",
    emojiFlag: "🇰🇼",
    code: "KW",
    dialCode: "+965",
  },
  {
    name: "Kyrgyzstan",
    emojiFlag: "🇰🇬",
    code: "KG",
    dialCode: "+996",
  },
  {
    name: "Laos",
    emojiFlag: "🇱🇦",
    code: "LA",
    dialCode: "+856",
  },
  {
    name: "Latvia",
    emojiFlag: "🇱🇻",
    code: "LV",
    dialCode: "+371",
  },
  {
    name: "Lebanon",
    emojiFlag: "🇱🇧",
    code: "LB",
    dialCode: "+961",
  },
  {
    name: "Lesotho",
    emojiFlag: "🇱🇸",
    code: "LS",
    dialCode: "+266",
  },
  {
    name: "Liberia",
    emojiFlag: "🇱🇷",
    code: "LR",
    dialCode: "+231",
  },
  {
    name: "Libyan Arab Jamahiriya",
    emojiFlag: "🇱🇾",
    code: "LY",
    dialCode: "+218",
  },
  {
    name: "Liechtenstein",
    emojiFlag: "🇱🇮",
    code: "LI",
    dialCode: "+423",
  },
  {
    name: "Lithuania",
    emojiFlag: "🇱🇹",
    code: "LT",
    dialCode: "+370",
  },
  {
    name: "Luxembourg",
    emojiFlag: "🇱🇺",
    code: "LU",
    dialCode: "+352",
  },
  {
    name: "Macao",
    emojiFlag: "🇲🇴",
    code: "MO",
    dialCode: "+853",
  },
  {
    name: "Macedonia",
    emojiFlag: "🇲🇰",
    code: "MK",
    dialCode: "+389",
  },
  {
    name: "Madagascar",
    emojiFlag: "🇲🇬",
    code: "MG",
    dialCode: "+261",
  },
  {
    name: "Malawi",
    emojiFlag: "🇲🇼",
    code: "MW",
    dialCode: "+265",
  },
  {
    name: "Malaysia",
    emojiFlag: "🇲🇾",
    code: "MY",
    dialCode: "+60",
  },
  {
    name: "Maldives",
    emojiFlag: "🇲🇻",
    code: "MV",
    dialCode: "+960",
  },
  {
    name: "Mali",
    emojiFlag: "🇲🇱",
    code: "ML",
    dialCode: "+223",
  },
  {
    name: "Malta",
    emojiFlag: "🇲🇹",
    code: "MT",
    dialCode: "+356",
  },
  {
    name: "Marshall Islands",
    emojiFlag: "🇲🇭",
    code: "MH",
    dialCode: "+692",
  },
  {
    name: "Martinique",
    emojiFlag: "🇲🇶",
    code: "MQ",
    dialCode: "+596",
  },
  {
    name: "Mauritania",
    emojiFlag: "🇲🇷",
    code: "MR",
    dialCode: "+222",
  },
  {
    name: "Mauritius",
    emojiFlag: "🇲🇺",
    code: "MU",
    dialCode: "+230",
  },
  {
    name: "Mayotte",
    emojiFlag: "🇾🇹",
    code: "YT",
    dialCode: "+262",
  },
  {
    name: "Mexico",
    emojiFlag: "🇲🇽",
    code: "MX",
    dialCode: "+52",
    flag: "red",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    emojiFlag: "🇫🇲",
    code: "FM",
    dialCode: "+691",
  },
  {
    name: "Moldova",
    emojiFlag: "🇲🇩",
    code: "MD",
    dialCode: "+373",
  },
  {
    name: "Monaco",
    emojiFlag: "🇲🇨",
    code: "MC",
    dialCode: "+377",
  },
  {
    name: "Mongolia",
    emojiFlag: "🇲🇳",
    code: "MN",
    dialCode: "+976",
  },
  {
    name: "Montenegro",
    emojiFlag: "🇲🇪",
    code: "ME",
    dialCode: "+382",
  },
  {
    name: "Montserrat",
    emojiFlag: "🇲🇸",
    code: "MS",
    dialCode: "+1664",
  },
  {
    name: "Morocco",
    emojiFlag: "🇲🇦",
    code: "MA",
    dialCode: "+212",
  },
  {
    name: "Mozambique",
    emojiFlag: "🇲🇿",
    code: "MZ",
    dialCode: "+258",
  },
  {
    name: "Myanmar",
    emojiFlag: "🇲🇲",
    code: "MM",
    dialCode: "+95",
    flag: "red",
  },
  {
    name: "Namibia",
    emojiFlag: "🇳🇦",
    code: "NA",
    dialCode: "+264",
  },
  {
    name: "Nauru",
    emojiFlag: "🇳🇷",
    code: "NR",
    dialCode: "+674",
  },
  {
    name: "Nepal",
    emojiFlag: "🇳🇵",
    code: "NP",
    dialCode: "+977",
  },
  {
    name: "Netherlands",
    emojiFlag: "🇳🇱",
    code: "NL",
    dialCode: "+31",
  },
  {
    name: "Netherlands Antilles",
    emojiFlag: "",
    code: "AN",
    dialCode: "+599",
  },
  {
    name: "New Caledonia",
    emojiFlag: "🇳🇨",
    code: "NC",
    dialCode: "+687",
  },
  {
    name: "New Zealand",
    emojiFlag: "🇳🇿",
    code: "NZ",
    dialCode: "+64",
  },
  {
    name: "Nicaragua",
    emojiFlag: "🇳🇮",
    code: "NI",
    dialCode: "+505",
  },
  {
    name: "Niger",
    emojiFlag: "🇳🇪",
    code: "NE",
    dialCode: "+227",
  },
  {
    name: "Nigeria",
    emojiFlag: "🇳🇬",
    code: "NG",
    dialCode: "+234",
  },
  {
    name: "Niue",
    emojiFlag: "🇳🇺",
    code: "NU",
    dialCode: "+683",
  },
  {
    name: "Norfolk Island",
    emojiFlag: "🇳🇫",
    code: "NF",
    dialCode: "+672",
  },
  {
    name: "Northern Mariana Islands",
    emojiFlag: "🇲🇵",
    code: "MP",
    dialCode: "+1670",
  },
  {
    name: "Norway",
    emojiFlag: "🇳🇴",
    code: "NO",
    dialCode: "+47",
  },
  {
    name: "Oman",
    emojiFlag: "🇴🇲",
    code: "OM",
    dialCode: "+968",
  },
  {
    name: "Pakistan",
    emojiFlag: "🇵🇰",
    code: "PK",
    dialCode: "+92",
  },
  {
    name: "Palau",
    emojiFlag: "🇵🇼",
    code: "PW",
    dialCode: "+680",
  },
  {
    name: "Palestinian Territory, Occupied",
    emojiFlag: "🇵🇸",
    code: "PS",
    dialCode: "+970",
  },
  {
    name: "Panama",
    emojiFlag: "🇵🇦",
    code: "PA",
    dialCode: "+507",
  },
  {
    name: "Papua New Guinea",
    emojiFlag: "🇵🇬",
    code: "PG",
    dialCode: "+675",
  },
  {
    name: "Paraguay",
    emojiFlag: "🇵🇾",
    code: "PY",
    dialCode: "+595",
  },
  {
    name: "Peru",
    emojiFlag: "🇵🇪",
    code: "PE",
    dialCode: "+51",
  },
  {
    name: "Philippines",
    emojiFlag: "🇵🇭",
    code: "PH",
    dialCode: "+63",
  },
  {
    name: "Pitcairn",
    emojiFlag: "🇵🇳",
    code: "PN",
    dialCode: "+64",
  },
  {
    name: "Poland",
    emojiFlag: "🇵🇱",
    code: "PL",
    dialCode: "+48",
  },
  {
    name: "Portugal",
    emojiFlag: "🇵🇹",
    code: "PT",
    dialCode: "+351",
  },
  {
    name: "Puerto Rico",
    emojiFlag: "🇵🇷",
    code: "PR",
    dialCode: "+1939",
  },
  {
    name: "Qatar",
    emojiFlag: "🇶🇦",
    code: "QA",
    dialCode: "+974",
  },
  {
    name: "Romania",
    emojiFlag: "🇷🇴",
    code: "RO",
    dialCode: "+40",
  },
  {
    name: "Russian Federation",
    emojiFlag: "🇷🇺",
    code: "RU",
    dialCode: "+7",
    flag: "red",
  },
  {
    name: "Rwanda",
    emojiFlag: "🇷🇼",
    code: "RW",
    dialCode: "+250",
  },
  {
    name: "Reunion",
    emojiFlag: "🇷🇪",
    code: "RE",
    dialCode: "+262",
  },
  {
    name: "Saint Barthelemy",
    emojiFlag: "🇧🇱",
    code: "BL",
    dialCode: "+590",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    emojiFlag: "🇸🇭",
    code: "SH",
    dialCode: "+290",
  },
  {
    name: "Saint Kitts and Nevis",
    emojiFlag: "🇰🇳",
    code: "KN",
    dialCode: "+1869",
  },
  {
    name: "Saint Lucia",
    emojiFlag: "🇱🇨",
    code: "LC",
    dialCode: "+1758",
  },
  {
    name: "Saint Martin",
    emojiFlag: "🇲🇫",
    code: "MF",
    dialCode: "+590",
  },
  {
    name: "Saint Pierre and Miquelon",
    emojiFlag: "🇵🇲",
    code: "PM",
    dialCode: "+508",
  },
  {
    name: "Saint Vincent and the Grenadines",
    emojiFlag: "🇻🇨",
    code: "VC",
    dialCode: "+1784",
  },
  {
    name: "Samoa",
    emojiFlag: "🇼🇸",
    code: "WS",
    dialCode: "+685",
  },
  {
    name: "San Marino",
    emojiFlag: "🇸🇲",
    code: "SM",
    dialCode: "+378",
  },
  {
    name: "Sao Tome and Principe",
    emojiFlag: "🇸🇹",
    code: "ST",
    dialCode: "+239",
  },
  {
    name: "Saudi Arabia",
    emojiFlag: "🇸🇦",
    code: "SA",
    dialCode: "+966",
  },
  {
    name: "Senegal",
    emojiFlag: "🇸🇳",
    code: "SN",
    dialCode: "+221",
  },
  {
    name: "Serbia",
    emojiFlag: "🇷🇸",
    code: "RS",
    dialCode: "+381",
  },
  {
    name: "Seychelles",
    emojiFlag: "🇸🇨",
    code: "SC",
    dialCode: "+248",
  },
  {
    name: "Sierra Leone",
    emojiFlag: "🇸🇱",
    code: "SL",
    dialCode: "+232",
  },
  {
    name: "Singapore",
    emojiFlag: "🇸🇬",
    code: "SG",
    dialCode: "+65",
  },
  {
    name: "Slovakia",
    emojiFlag: "🇸🇰",
    code: "SK",
    dialCode: "+421",
  },
  {
    name: "Slovenia",
    emojiFlag: "🇸🇮",
    code: "SI",
    dialCode: "+386",
  },
  {
    name: "Solomon Islands",
    emojiFlag: "🇸🇧",
    code: "SB",
    dialCode: "+677",
  },
  {
    name: "Somalia",
    emojiFlag: "🇸🇴",
    code: "SO",
    dialCode: "+252",
  },
  {
    name: "South Africa",
    emojiFlag: "🇿🇦",
    code: "ZA",
    dialCode: "+27",
  },
  {
    name: "South Sudan",
    emojiFlag: "🇸🇸",
    code: "SS",
    dialCode: "+211",
    flag: "red",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    emojiFlag: "🇬🇸",
    code: "GS",
    dialCode: "+500",
  },
  {
    name: "Spain",
    emojiFlag: "🇪🇸",
    code: "ES",
    dialCode: "+34",
  },
  {
    name: "Sri Lanka",
    emojiFlag: "🇱🇰",
    code: "LK",
    dialCode: "+94",
  },
  {
    name: "Sudan",
    emojiFlag: "🇸🇩",
    code: "SD",
    dialCode: "+249",
    flag: "red",
  },
  {
    name: "Suriname",
    emojiFlag: "🇸🇷",
    code: "SR",
    dialCode: "+597",
  },
  {
    name: "Svalbard and Jan Mayen",
    emojiFlag: "🇸🇯",
    code: "SJ",
    dialCode: "+47",
  },
  {
    name: "Swaziland",
    emojiFlag: "🇸🇿",
    code: "SZ",
    dialCode: "+268",
  },
  {
    name: "Sweden",
    emojiFlag: "🇸🇪",
    code: "SE",
    dialCode: "+46",
  },
  {
    name: "Switzerland",
    emojiFlag: "🇨🇭",
    code: "CH",
    dialCode: "+41",
  },
  {
    name: "Syrian Arab Republic",
    emojiFlag: "🇸🇾",
    code: "SY",
    dialCode: "+963",
    flag: "red",
  },
  {
    name: "Taiwan",
    emojiFlag: "🇹🇼",
    code: "TW",
    dialCode: "+886",
  },
  {
    name: "Tajikistan",
    emojiFlag: "🇹🇯",
    code: "TJ",
    dialCode: "+992",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    emojiFlag: "🇹🇿",
    code: "TZ",
    dialCode: "+255",
  },
  {
    name: "Thailand",
    emojiFlag: "🇹🇭",
    code: "TH",
    dialCode: "+66",
  },
  {
    name: "Timor-Leste",
    emojiFlag: "🇹🇱",
    code: "TL",
    dialCode: "+670",
  },
  {
    name: "Togo",
    emojiFlag: "🇹🇬",
    code: "TG",
    dialCode: "+228",
  },
  {
    name: "Tokelau",
    emojiFlag: "🇹🇰",
    code: "TK",
    dialCode: "+690",
  },
  {
    name: "Tonga",
    emojiFlag: "🇹🇴",
    code: "TO",
    dialCode: "+676",
  },
  {
    name: "Trinidad and Tobago",
    emojiFlag: "🇹🇹",
    code: "TT",
    dialCode: "+1868",
  },
  {
    name: "Tunisia",
    emojiFlag: "🇹🇳",
    code: "TN",
    dialCode: "+216",
  },
  {
    name: "Turkey",
    emojiFlag: "🇹🇷",
    code: "TR",
    dialCode: "+90",
  },
  {
    name: "Turkmenistan",
    emojiFlag: "🇹🇲",
    code: "TM",
    dialCode: "+993",
  },
  {
    name: "Turks and Caicos Islands",
    emojiFlag: "🇹🇨",
    code: "TC",
    dialCode: "+1649",
  },
  {
    name: "Tuvalu",
    emojiFlag: "🇹🇻",
    code: "TV",
    dialCode: "+688",
  },
  {
    name: "Uganda",
    emojiFlag: "🇺🇬",
    code: "UG",
    dialCode: "+256",
  },
  {
    name: "Ukraine",
    emojiFlag: "🇺🇦",
    code: "UA",
    dialCode: "+380",
    flag: "red",
  },
  {
    name: "United Arab Emirates",
    emojiFlag: "🇦🇪",
    code: "AE",
    dialCode: "+971",
  },
  {
    name: "United Kingdom",
    emojiFlag: "🇬🇧",
    code: "GB",
    dialCode: "+44",
  },
  {
    name: "Uruguay",
    emojiFlag: "🇺🇾",
    code: "UY",
    dialCode: "+598",
  },
  {
    name: "Uzbekistan",
    emojiFlag: "🇺🇿",
    code: "UZ",
    dialCode: "+998",
  },
  {
    name: "Vanuatu",
    emojiFlag: "🇻🇺",
    code: "VU",
    dialCode: "+678",
  },
  {
    name: "Venezuela",
    emojiFlag: "🇻🇪",
    code: "VE",
    dialCode: "+58",
    flag: "red",
  },
  {
    name: "Vietnam",
    emojiFlag: "🇻🇳",
    code: "VN",
    dialCode: "+84",
  },
  {
    name: "Virgin Islands, British",
    emojiFlag: "🇻🇬",
    code: "VG",
    dialCode: "+1284",
  },
  {
    name: "Virgin Islands, U.S.",
    emojiFlag: "🇻🇮",
    code: "VI",
    dialCode: "+1340",
  },
  {
    name: "Wallis and Futuna",
    emojiFlag: "🇼🇫",
    code: "WF",
    dialCode: "+681",
  },
  {
    name: "Yemen",
    emojiFlag: "🇾🇪",
    code: "YE",
    dialCode: "+967",
  },
  {
    name: "Zambia",
    emojiFlag: "🇿🇲",
    code: "ZM",
    dialCode: "+260",
  },
  {
    name: "Zimbabwe",
    emojiFlag: "🇿🇼",
    code: "ZW",
    dialCode: "+263",
    flag: "red",
  },
] as const;

export { countries };
